<script lang="ts">
  // Compact metric tile — label, big number, optional delta and hint. Shared
  // by the overview surfaces that already have real stats behind them (the
  // site / owner dashboards, via StatStrip); deliberately no sparkline, the
  // main Dashboard's KPI row owns that richer treatment.
  const {
    label,
    value,
    /** Short signed change, e.g. "+3 vs last wk". Rendered next to the label. */
    delta,
    /** Tints `delta` — 'up' is green, 'down' red, 'flat' muted. */
    deltaTone = 'flat',
    /** Muted line under the value. */
    hint,
    /** Overrides the value color (stage/status tints). */
    valueColor
  }: {
    label: string;
    value: string | number;
    delta?: string;
    deltaTone?: 'up' | 'down' | 'flat';
    hint?: string;
    valueColor?: string;
  } = $props();
</script>

<div class="tym-insight-card">
  <div class="flex items-baseline justify-between gap-2">
    <span class="tym-insight-label">{label}</span>
    {#if delta}
      <span class="tym-insight-delta {deltaTone}">{delta}</span>
    {/if}
  </div>
  <div class="tym-insight-value" style={valueColor ? `color:${valueColor}` : undefined}>{value}</div>
  {#if hint}
    <div class="tym-insight-hint">{hint}</div>
  {/if}
</div>
